import * as React from 'react';
import * as Scrollbar from 'react-smooth-scrollbar';
import SmoothScrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';

SmoothScrollbar.use(OverscrollPlugin);

export default ({style, children, className}) =>
    <Scrollbar className={className} style={style}>
        {children}
    </Scrollbar>;




// WEBPACK FOOTER //
// ./src/components/utility/customScrollBar.tsx